let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1ynwl")).then(() => parcelRequire('filOk'));